import { useQuery } from 'react-query';
import * as PretaxAccountApi from 'apis/pretaxAccount';
import { AxiosError } from 'axios';

export type IPretaxAccount =
  PretaxAccountApi.FetchAccountsResponse['accounts'][0];

type GetAlegeusPretaxAccountsResponse = {
  pretax_accounts: Array<IPretaxAccount>;
};

const getAlegeusPretaxAccounts =
  async (): Promise<GetAlegeusPretaxAccountsResponse> => {
    const {
      data: { accounts },
    } = await PretaxAccountApi.fetchAccounts();
    return { pretax_accounts: accounts };
  };

const useQueryAlegeusPretaxAccounts = ({
  enabled,
  onError,
  onSuccess,
}: {
  enabled: boolean;
  onError?: (error: AxiosError) => void;
  onSuccess?: (data: GetAlegeusPretaxAccountsResponse) => void;
}) => {
  const { data, isLoading, isError } = useQuery(
    ['getAlegeusPretaxAccounts'],
    () => getAlegeusPretaxAccounts(),
    {
      enabled,
      onError,
      onSuccess,
    }
  );

  return {
    data,
    isLoading,
    isError,
  };
};

export default useQueryAlegeusPretaxAccounts;
